module.exports = __webpack_public_path__ + "img/guidon.9f2fa4df.png";